var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M84.9634 47.8643C76.7374 50.0684 69.146 53.2305 61.1315 56.2239C61.014 56.2554 59.322 51.3511 59.8743 51.0621C62.3657 49.5486 65.1625 48.2352 67.8771 47.0849C56.5607 45.7464 45.2562 41.1619 35.0093 36.2941C21.0021 29.614 8.29952 19.3415 1.17895 4.04855C0.626699 2.92761 0.685547 0.796978 0.239028 0.0706768C7.70036 15.6953 21.1551 25.4842 35.6794 31.7438C48.817 37.529 63.5294 42.6102 77.3842 40.7307C75.7391 39.7616 74.0939 38.7925 72.9893 37.9606C69.6756 35.4647 66.4441 32.8058 63.577 29.6263C63.2009 29.1631 63.3303 27.2956 62.9895 26.9639C67.4901 30.1287 71.7439 33.7826 76.409 36.6213C79.429 38.4909 82.5901 39.4768 83.9648 43.1972C84.2585 43.8234 85.4335 47.7383 84.9634 47.8643Z"}));
}

ArrowRight.defaultProps = {"width":"86","height":"57","viewBox":"0 0 86 57"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
